import { Navigate, Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/app/providers/AuthProvider';
import { LgpdConsentModal } from '@/features/auth/LgpdConsentModal';
import type { UserRole } from '@/types/database';

interface ProtectedRouteProps {
  allowedRoles: UserRole[];
}

export function ProtectedRoute({ allowedRoles }: ProtectedRouteProps) {
  const { session, profile, loading, needsLgpdConsent } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-secondary">
        <Loader2 className="animate-spin text-primary" size={32} />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Profile não encontrado — mostrar erro em vez de loop infinito
  if (!profile) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-secondary p-8 text-center">
        <p className="font-medium text-foreground">Não foi possível carregar seu perfil.</p>
        <button onClick={() => window.location.reload()} className="text-sm text-primary underline">
          Tentar novamente
        </button>
      </div>
    );
  }

  if (!allowedRoles.includes(profile.role)) {
    // Role errado: redireciona para a área correta
    if (profile.role === 'cliente') return <Navigate to="/portal" replace />;
    return <Navigate to="/app" replace />;
  }

  return (
    <>
      {needsLgpdConsent && <LgpdConsentModal />}
      <Outlet />
    </>
  );
}
